import {Component, OnInit} from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {DateAdapter, NativeDateAdapter} from '@angular/material/core';
import {AuthService} from '../../core/security/auth.service';
import {CurrentUserAccountModel} from '../../api/models/current-user-account-model';
import {MatAlertDialogComponent} from '../mat-alert/mat-alert-dialog.component';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-mat-switch-company-dialog',
    providers: [
        { provide: DateAdapter, useClass: NativeDateAdapter },
    ],
    templateUrl: './mat-switch-company-dialog.component.html',
    styleUrls: ['./mat-switch-company-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, FlexModule, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, NgFor, MatButton, MatDialogActions]
})
export class MatSwitchCompanyDialogComponent implements OnInit {

  companies: Array<CurrentUserAccountModel>;
  constructor(public dialogRef: MatDialogRef<MatSwitchCompanyDialogComponent>,
              public dialog: MatDialog,
              private authService: AuthService
              ) {

  }

  ngOnInit() {
    console.log('MatSwitchCompanyDialogComponent - ngOnInit')
    const currentUser = this.authService.currentUser.getValue();
    if (currentUser) {
      this.companies = currentUser.accounts;
    }
  }

  closeSendConfirmPopup(action: string) {
    if (action === 'close') {
      this.dialogRef.close();
    }
  }

  onCompanySelect(company: any) {
    this.authService.switchCompany(company).then((value) => {
      this.dialogRef.close();
      if (value) {
        window.location.assign('/');
      } else {
        this.dialog.open(MatAlertDialogComponent, {
          width: '500px',
          data: {
            title: 'Error',
            actionTitle: 'Close',
            text: 'Unable to switch company',
          }
        });
      }
    }).catch((err) => {
      this.dialogRef.close();
      this.dialog.open(MatAlertDialogComponent, {
        width: '500px',
        data: {
          title: 'Error',
          actionTitle: 'Close',
          text: 'Unable to switch company',
        }
      });
    });
  }
}
